import { useEffect } from 'react';

export default function MerchandisingRedirect() {
    useEffect(() => { window.location.replace('/command-center/merchandising'); }, []);
    return <div className="p-8 text-gray-500">Opening Merchandising KPIs…</div>;
}
